import Vue from 'vue'
// Time formatter
import moment from 'moment'

Vue.mixin({
    methods: {
        CheckError (error) {
            if ((error.message.toLowerCase().indexOf('session') > -1)) {
                this.$store.commit('ShowError', error.message)
                this.ReLogin()
            } else if ((error.networkError && error.networkError.statusCode === 504)) {
                this.$store.commit('ShowError', error.message)
            } else if ((error.message.toLowerCase().indexOf('failed to fetch') > -1)) {
                this.$store.commit('ShowError', 'Failed to fetch!')
                this.$router.go()
            } else {
                this.$store.commit('ShowError', this.default_error)
                this.ReLogin()
            }
        },
        ReLogin () {
            setTimeout(() => {
                window.location.href = '/login'
            }, 500)
        },
        GetIntToTime (t) {
           if (t > 24) { t = t - 24 }
           var i = moment.utc(t, 'HH:mm')
           return moment.utc(i).format('HH:mm').replace(':05', ':30')
        },
        GetTimeToInt (t, s) {
            var i = moment.utc(t, 'HH:mm')
            var n = Number(moment.utc(i).format('H.m').replace('.3', '.5'))
            // parse time using 24-hour clock and use UTC to prevent DST issues
            var start = moment.utc(s, 'HH:mm')
            // account for crossing over to midnight the next day
            if (i.isBefore(start)) n += 24
            return n
         },
        GetTimeSpan (s, e) {
            // parse time using 24-hour clock and use UTC to prevent DST issues
            var start = moment.utc(s, 'HH:mm')
            var end = moment.utc(e, 'HH:mm')
            // account for crossing over to midnight the next day
            if (end.isBefore(start)) end.add(1, 'day')

            // calculate the duration
            var d = moment.duration(end.diff(start))

            // format a string result
            return d.asHours()
        },
        GetDateTimeSpan (s, e) {
            // parse time using 24-hour clock and use UTC to prevent DST issues
            var start = moment.utc(s, 'YYYY-MM-DD HH:mm')
            var end = moment.utc(e, 'YYYY-MM-DD HH:mm')
            // account for crossing over to midnight the next day
            if (end.isBefore(start)) end.add(1, 'day')

            // calculate the duration
            var d = moment.duration(end.diff(start))

            // format a string result
            return d.asHours()
        },
        ValidateInput (evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        ValidateInput2 (evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if ((charCode !== 46 && charCode !== 48 &&
                charCode !== 49 && charCode !== 53 && charCode > 31)) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        NumberWithComma (val) {
            return val.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
        },
    },
})
